import PropTypes from "prop-types";

const SidebarNavItem = ({ label, active, onClick, badge }) => {
  return (
    <button
      type="button"
      onClick={onClick}
      aria-current={active ? "location" : undefined}
      className={`relative w-full text-left text-sm py-2 px-3 rounded-md transition-colors duration-150 min-h-[44px] flex items-center justify-between ${
        active
          ? "text-ink-900 font-medium"
          : "text-ink-500 hover:text-ink-900"
      }`}
    >
      {active && (
        <span
          aria-hidden="true"
          className="absolute left-0 top-2 bottom-2 w-[2px] rounded-pill bg-accent-500"
        />
      )}
      <span className="truncate">{label}</span>
      {badge && (
        <span className="ml-2 inline-flex items-center px-1.5 py-0.5 rounded-pill text-[11px] font-medium bg-accent-100 text-accent-700 shrink-0">
          {badge}
        </span>
      )}
    </button>
  );
};

SidebarNavItem.propTypes = {
  label: PropTypes.string.isRequired,
  active: PropTypes.bool,
  onClick: PropTypes.func.isRequired,
  badge: PropTypes.string,
};

export default SidebarNavItem;
